import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    projId,
    itemId,
    sumWeight = 0.0,
    discache = false,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpi.aiReasonerItems, {
        projId,
        itemId,
        sumWeight,
        discache,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
